import wrap from 'wraptile';

// Warning: An effect function must not return anything besides a function, which is used for clean-up. You returned: [object Object]
const handleUnmount = wrap((resetData: any) => resetData);

export default handleUnmount;
